export default {
  items: [
    {
      _name: 'CSidebarNav',
      _children: [
        {
          _name: 'CSidebarNavItem',
          name: 'Bảng điều khiển',
          icon: 'cil-speedometer',
          to: '/dashboard.html'
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản trị hệ thống',
          icon: 'cib-overcast',
          items: [
            {
              name: 'Danh sách hệ thống',
              to: '/system-management/managed-system',
            },
            {
              name: 'Nhật ký hệ thống',
              to: '/system-management/action-log',
            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản trị tài khoản',
          icon: 'cil-people',
          items: [
            {
              name: 'Danh sách tài khoản',
              to: '/user-management/managed-users',
            },
            {
              name: 'Danh sách chức vụ',
              to: '/user-management/managed-position',
            },
            {
              name: 'Đổi mật khẩu',
              // icon: 'cil-user',
              to: '/user/reset-password.html'
            },
          ]
        },
      ]
    },
  ]
}
